export default __webpack_public_path__ + "static/media/ThothLegacy-Regular.d8c06652.ttf";